import { render, staticRenderFns } from "./NuevoPrecioModeloMasivoV2.vue?vue&type=template&id=71574dd4"
import script from "./NuevoPrecioModeloMasivoV2.vue?vue&type=script&lang=js"
export * from "./NuevoPrecioModeloMasivoV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports